module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/fiascoCover_1x.45828cb.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/fiascoCover_1x.png
// module id = 1hez
// module chunks = 41